import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const MpesaProcessing = ({ isMpesaProcessing }) => {
  const controlsFirst = useAnimation();
  const controlsSecond = useAnimation();
  const controlsThird = useAnimation();

  useEffect(() => {
    if (isMpesaProcessing) {
      controlsFirst.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0,
        },
      });

      controlsSecond.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.2,
        },
      });

      controlsThird.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.4,
        },
      });
    } else {
      controlsFirst.stop();
      controlsSecond.stop();
      controlsThird.stop();
    }
  }, [isMpesaProcessing, controlsFirst, controlsSecond, controlsThird]);

  return (
    <SlidePanel isOpen={isMpesaProcessing} onClose={() => {}}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Optional Close (hidden logic-safe) */}
        <div className="absolute top-0 right-0 h-[40px] w-[40px] opacity-0">
          <X />
        </div>

        <div className="flex flex-col h-full justify-center items-center mt-5 px-10">
          {/* ✅ CENTERED LOADING DOTS */}
          <div className="flex items-center justify-center mb-6">
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsFirst}
            />
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsSecond}
            />
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsThird}
            />
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default MpesaProcessing;
